<template>
    <div :class="['move-file','dialog-wraper',error ? 'form-error' : '']">
        <div class="folder-name">
            <el-input maxlength="100" :placeholder="dialogData.tid ? $t('TeamPlaceholder',{name: uname}) : $t('Newfileinfo')" v-model.trim="name" @keyup.native.enter="onConfirm" ref="input">
                <template v-if="dialogData.ftype === 'file'" slot="append">.{{dialogData.ext}}</template>
            </el-input>
            <p v-if="error" class="name-error">{{$t(error)}}</p>
        </div>
        <div class="dialog-foot">
             <el-button size="mini" @click="doclose" v-cloak>{{$t('Cancel')}}</el-button><el-button :loading="doing || teamLoading" :disabled="isdisabled" @click="onConfirm" type="primary" size="mini" v-cloak>{{$t('Confirm')}}</el-button>
        </div>
        
    </div>
</template>

<script>
import { mapActions, mapState,mapMutations } from "vuex"

export default {
    data(){
        return {
            parentid: 0,
            name: '',
            error: ''
        }
    },
    created(){
        this.name = this.dialogData.from == 'Settings' ? this.currentTeam.name : (this.dialogData.name || this.dialogData.tname )
    },
    mounted(){
        let dom = this.$refs.input
        dom.focus()
        dom.select()
    },
    computed:{
        ...mapState([
            'dialogData'
        ]),
        uname(){
            return this.$store.state.user.name
        },
        ...mapState('index',[
            'doing'
        ]),
        ...mapState('team',[
            'teamLoading',
            'currentTeam'
        ]),
        isdisabled(){
            return !this.name || this.name == (this.dialogData.name || this.dialogData.tname) || !!this.error || (this.dialogData.from == 'Settings' && this.currentTeam.name == this.name)
        }
    },
    methods:{
        ...mapActions('index',[
            'rename'
        ]),
        ...mapActions('team',[
            'renameTeam'
        ]),
        ...mapActions([
            'close'
        ]),
        ...mapMutations([
            'SHOW_DIALOG'
        ]),
        doclose(){
            if (this.dialogData.from == 'Settings') {
                this.SHOW_DIALOG({
                    title: this.$t('Settings'),
                    current: 'Settings'
                })
            }else{
                this.close()
            }
        },
        onConfirm(){
            if (this.isdisabled) {
                return
            }
            let {name,ext,fileid,ftype,tid} = this.dialogData
            tid ?
            this.renameTeam({
                tname: this.name,
                tid
            }) :
            this.rename({
                fname: ftype == 'folder' ? this.name : `${this.name}.${ext}`,
                fileid
            })
        }
    },
    watch:{
        name(cur){
            let reg = /^[^/\\:*?"<>|]+$/
            if (!reg.test(cur) && cur) {
                this.error = 'illegalFname'
            }else if(cur.length > 50){
                this.error = 'groupLengthTooLong'
            }else{
                this.error = ''
            }
        }
    }

}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/dialog/file/Rename.vue